import { render } from "./TotalBox.vue?vue&type=template&id=4e01f9d4&scoped=true"
import script from "./TotalBox.vue?vue&type=script&lang=js"
export * from "./TotalBox.vue?vue&type=script&lang=js"

import "./TotalBox.vue?vue&type=style&index=0&id=4e01f9d4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e01f9d4"]])

export default __exports__